export default __webpack_public_path__ + "static/media/logo.86a3af26.png";